import { useId } from "react";
import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setMultiSelectParams } from "@/src/store/filter";

import InnerBox from "@/src/components/listing-search/inner-box";
import ChexBoxGroup from "@/src/components/listing-search/filter-items/params-filter/multi-select/checkbox-group";

import styles from "../../styles.module.css";

const MultiSelectFilter = ({ filter }) => {
  const keyId = useId();
  const ReduxMultiSelectItems = useSelector((state) => state.filter.multiselectitems);

  const dispatch = useDispatch();
  const handleChangeFilter = (item, key) => {
    dispatch(
      setMultiSelectParams([
        ...ReduxMultiSelectItems.filter((multiItem) => multiItem.key !== key),
        { key, value: item },
      ])
    );
  };

  const categorizeFilter = (filter) => {
    const categories = filter.config.values.reduce((acc, item) => {
      acc[item.category] = acc[item.category] || [];
      acc[item.category].push(item);
      return acc;
    }, {});

    return [Object.keys(categories), Object.values(categories)];
  };

  const getFilterValueByKey = (key) => {
    const filterByKey = ReduxMultiSelectItems.find((item) => item.key === key);

    return filterByKey?.value || [];
  };

  return (
    <>
      {[
        "indoor_features",
        "outdoor_features",
        "location_features",
        "facility_features",
        "other_features",
        "usage_features",
      ].includes(filter?.key) ? (
        <InnerBox title={filter?.name} isHidden={!filter?.hidden} isDropdownView>
          {categorizeFilter(filter)[1]?.map((item, index) => {
            const filterKey = filter?.key;
            return (
              <div key={`${keyId}+${index}`}>
                <InnerBox title={categorizeFilter(filter)[0][index]} isDropdownView subItem>
                  <div className={styles.subCheckBoxWrapper}>
                    <ChexBoxGroup
                      property={item}
                      name={item?.category}
                      checkBoxClass={styles.checkBoxClass}
                      onChange={(selectedItem, key) => handleChangeFilter(selectedItem, filterKey)}
                      selected={getFilterValueByKey(filterKey) || []}
                    />
                  </div>
                </InnerBox>
                <hr className={styles.line} />
              </div>
            );
          })}
        </InnerBox>
      ) : (
        <>
          <InnerBox isDropdownView isHidden={!filter?.hidden} title={filter?.name}>
            <div className={styles.checkBoxWrapper}>
              <ChexBoxGroup
                property={filter}
                name={filter?.category}
                checkBoxClass={styles.checkBoxClass}
                onChange={handleChangeFilter}
                selected={getFilterValueByKey(filter.key) || []}
              />
            </div>
          </InnerBox>
          <hr className={styles.line} />
        </>
      )}
    </>
  );
};

MultiSelectFilter.propTypes = {
  filter: PropTypes.object,
};

export default MultiSelectFilter;
